import {QuickEditEventFormValidationSchema} from '@/features/agenda/formSchemas'
import {zodResolver} from '@hookform/resolvers/zod'
import {ReactNode} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

export const AgendaEventDetailsFormProvider = ({
    children,
    defaultValues
}: {
    children: ReactNode
    defaultValues?: Partial<QuickEditEventFormValidationSchema>
}) => {
    const form = useForm<QuickEditEventFormValidationSchema>({
        mode: 'onBlur',
        resolver: zodResolver(QuickEditEventFormValidationSchema),
        defaultValues
    })

    return <FormProvider {...form}>{children}</FormProvider>
}
